import React, { useState } from 'react';
import { CCollapse, CCard, CCardBody, CButton } from '@coreui/react';
import '../css/AshadL.css';
import L11 from '../images/L11.png';
import L12 from '../images/L12.png';
import L21 from '../images/L21.png';
import L31 from '../images/L31.png';
import L32 from '../images/L32.png';
import L41 from '../images/L41.png';
import L42 from '../images/L42.png';
import L51 from '../images/L51.png';
import L52 from '../images/L52.png';


const ZahidL = () => {
    const [visible1, setVisible1] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [visible3, setVisible3] = useState(false);
    const [visible4, setVisible4] = useState(false);
    const [visible5, setVisible5] = useState(false);

    const toggleCard = (index) => {
        switch (index) {
            case 1:
                setVisible1(!visible1);
                break;
            case 2:
                setVisible2(!visible2);
                break;
            case 3:
                setVisible3(!visible3);
                break;
            case 4:
                setVisible4(!visible4);
                break;
            case 5:
                setVisible5(!visible5);
                break;
            default:
                break;
        }
    };

    return (
        <div className="ashad-container">
            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(1);
            }}>
               2021_IEEE_Collaborative Storytelling with Social Robots
            </a>
            <br />
            <CCollapse visible={visible1}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                        <div className="content-left">
                            <h5>Title: Collaborative Storytelling with Social Robots</h5>
                            <h6>Objective:</h6>
                            <p>
                                This paper explores collaborative storytelling with social robots and considers the design implications that arise. The researchers aim to examine the performance-latency trade-offs of an existing generate-and-rank-based approach to collaborative storytelling and improve the evaluation process by having human participants play the collaborative storytelling game with the system. They also conduct a pilot elicitation survey to gather insights on adapting the collaborative storytelling system to a social robot.
                            </p>
                            <img src={L11} alt="img1" />

                            <h6>Methods:</h6>
                            <p>
                                The paper examines the performance-latency trade-offs of an existing generate-and-rank-based approach to collaborative storytelling by finding the optimal ranker's sample size. The authors improve on existing evaluation methods by having human participants play the collaborative storytelling game with their system and comparing the stories they create with a naive baseline. The paper also mentions the use of a language model (LM) to generate story continuations.
                            </p>
                            <img src={L12} alt="img1" />

                            <h6>Results:</h6>
                            <p>
                                The paper explores a generate-and-rank approach for collaborative storytelling with social robots, evaluating performance-latency trade-offs. Human participants played the game and compared stories to a baseline, revealing that acceptability improved with ranker sample size but had diminishing returns, capped at 30 for balance.
                            </p>

                            <h6>Conclusions:</h6>
                            <p>
                                This paper explores collaborative storytelling with social robots, emphasizing design choices and performance considerations. Human participants evaluated the system, finding positive feedback on emotive interactions. A pilot survey highlighted factors for adapting the system. Acceptance of generated stories improved with ranker sample size up to 30, balancing quality and cost.
                            </p>

                            <h6>Limitations:</h6>
                            <p>
                                The paper evaluates collaborative storytelling with a social robot but overlooks story endings. The evaluation's reliance on a pilot survey and a basic baseline may limit its representativeness. While it caps the ranker sample size at 30 for efficiency, it doesn't explore larger samples.
                            </p>
                        </div>
                        <CButton color="danger" onClick={() => toggleCard(1)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(2);
            }}>
                2021_HCI_Storytelling Robots for Training of Emotion Recognition in Children with Autism; Opinions from Experts
            </a>
            <br />
            <CCollapse visible={visible2}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: Storytelling Robots for Training of Emotion Recognition in Children with Autism; Opinions from Experts</h5>

      <h6>Objective:</h6>
      <p>
        To validate a social robot's emotion recognition training for children with autism, the study sought feedback from ASD educators and experts. It aimed to assess whether adding situational context to robot gestures enhances emotion recognition accuracy and if experts find these emotional gestures suitable for training children with autism.
      </p>
      <img src={L21} alt="img1" />

      <h6>Methods:</h6>
      <p>
        A survey involved 26 participants, including 13 ASD experts and 13 non-experts, who assessed a social robot's emotion recognition training for children with autism. They viewed videos of the robot's emotional gestures, with and without situational context. Participants rated emotion recognition accuracy and the feasibility of these gestures for children with ASD. Recognition accuracy and Likert scores were analyzed across emotions, conditions, and groups using mixed ANOVA.
      </p>

      <h6>Results:</h6>
      <p>
        The study found that adding storytelling context significantly improved the feasibility of emotion recognition gestures for children with ASD, while gestures without storytelling were not practical. Experts gave lower feasibility scores to robot gestures than non-experts. This highlights the critical role of context in designing effective robot gestures for social skills training in children with ASD and underscores the need for validation by ASD experts in social robot interventions.
      </p>

      <h6>Conclusion:</h6>
      <p>
        I found that adding storytelling context enhances emotion recognition in robot gestures for children with ASD. Gesture recognition feasibility significantly improves with narratives, but ASD experts had lower confidence, revealing a need for better understanding. Social context is key for effective robot training programs for children with developmental disabilities, and professional validation is crucial.
      </p>

      <h6>Limitations of this paper:</h6>
      <p>
        The study's limitations include a small number of recruited participants, limited evaluation of gesture variations due to time constraints, potential bias from convenience sampling, the omission of sound effects, and the need for further research with a larger expert group for result confirmation.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(2)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(3);
            }}>
                2020_IEEE_Design Patterns for an Interactive Storytelling Robot to Support  Children’s Engagement and Agency
            </a>
            <br />
            <CCollapse visible={visible3}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: Design Patterns for an Interactive Storytelling Robot to Support Children’s Engagement and Agency</h5>

      <h6>Objective:</h6>
      <p>
        The paper aims to define and validate three interaction design patterns for interactive storytelling with a social robot, focusing on reducing stress in children. A user study with 27 children aged 8-10 assesses pattern effectiveness, engagement, and efficiency. Results validate patterns and suggest improvements for a smoother interaction.
      </p>
      <img src={L32} alt="img1" />

      <h6>Design Methods:</h6>
      <p>
        A study introduces three design patterns for interactive storytelling with a social robot, benefiting children's engagement and agency. Findings from 27 kids aged 8-10 indicate increased attention, enjoyment, and story recall. Nevertheless, technical problems may hinder the experience, indicating the necessity for software enhancements. These patterns show promise for various narratives and potential clinical applications but demand additional validation.
      </p>
        <img src={L31} alt="img1" />

      <h6>Result:</h6>
      <p>
        The study with 27 children (8-10 years old) found that using design patterns in robot-led storytelling improved attention, enjoyment, and story recall. Children felt more in control and valued their ability to influence the story. Most notably, 92% of them persisted even after facing challenges.
      </p>

      <h6>Conclusions:</h6>
      <p>
        The paper introduces three effective design patterns for interactive storytelling with social robots, benefiting children's engagement and agency. A study with 27 children (ages 8-10) showed increased attention, enjoyment, and story recall. Children appreciated their autonomy, but areas for improvement include reducing confusion and allowing more interaction time. Diverse story options could enhance inclusivity. Despite occasional speech recognition issues, technical improvements can address these interruptions.
      </p>

      <h6>Limitations:</h6>
      <p>
        The study's limitations include a small and non-diverse sample, potentially affecting the findings' generalizability. The design patterns were only tested in one school setting with two stories, necessitating further validation in various contexts. The paper acknowledges the need for a more diverse sample for inclusivity but lacks specific information on technical challenges during implementation.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(3)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(4);
            }}>
                2020_MDPI_A Virtual Assistant for Natural Interactions in Museums
            </a>
            <br />
            <CCollapse visible={visible4}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: A Virtual Assistant for Natural Interactions in Museums</h5>

      <h6>Objective:</h6>
      <p>
        This paper revolves around the development of an intelligent conversational agent aimed at enhancing information accessibility within a history museum. This involves the creation of an AI-based core that can effectively understand and communicate in the Romanian language. To gauge the acceptance levels of this virtual assistant among both museum visitors and staff, a survey will be conducted. Furthermore, the study seeks to demonstrate the flexibility of the implementation, allowing the system to cater to a diverse range of stakeholders with minimal adjustments.
      </p>
      <img src={L42} alt="img1" />

      <h6>Methods:</h6>
      <p>
        The paper discusses the creation of an intelligent conversational agent for a history museum, with a focus on implementing an AI core for Romanian language understanding. The system architecture incorporates cutting-edge solutions, such as Google Cloud Speech to Text, which was chosen after a comparison with several other frameworks, including Vonage, Amazon Transcribe, IBM Watson, Microsoft Bing Speech API, AssemblyAI, Kaldi, and Sayint.
      </p>
        <img src={L41} alt="img1" />

      <h6>Results:</h6>
      <p>
        Feedback on the conversational agent from visitors and museum staff was largely positive. A museum-conducted survey highlighted positive feedback in most areas, with the appearance of the avatar being the main area for improvement. Additionally, an open-ended question in the survey yielded valuable insights into functionality and miscellaneous feedback from a subset of respondents.
      </p>

      <h6>Conclusion:</h6>
      <p>
        Creating an intelligent virtual museum guide is a promising and immediately applicable research effort with long-term advantages. The system's flexible architecture demonstrated scalability and real-world viability. The user study revealed positive visitor reception. Furthermore, the paper identifies future research possibilities in digital cultural heritage and intelligent human-computer interfaces, paving the way for new research avenues in these domains.
      </p>

      <h6>Limitations:</h6>
      <p>
        The paper lacks specific details on research limitations. It recognizes the complexity of building a VR museum guide, involving challenges like accurate modeling, language understanding, and exhibit guidance. The methodology hinges on hypotheses to explore unknown factors and technological constraints. It also acknowledges the necessity for further evaluation and enhancements, particularly in avatar appearance and interaction design.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(4)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(5);
            }}>
                IEEE_Emotional Storytelling in the Classroom: Individual versus Group Interaction between Children and Robots
            </a>
            <br />
            <CCollapse visible={visible5}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: Emotional Storytelling in the Classroom: Individual versus Group Interaction between Children and Robots</h5>

      <h6>Objective:</h6>
      <p>
        This paper compared individual and group interactions with robots in an educational context, focusing on their impact on children's story recall and emotional interpretation. It also examined how the story's difficulty level affected emotional interpretation. The research aimed to assess whether interactive narratives with multiple robots could enhance children's social skills, regardless of the interaction type.
      </p>
        <img src={L52} alt="img1" />

      <h6>Methods:</h6>
      <p>
        The study employed a between-subjects repeated interaction design, assigning participants to individual or group conditions. A narrative system with JSON story scripts and a story manager facilitated the interactive storytelling with MyKeepon robots. These robots, controlled by an Arduino board, had four degrees of freedom and could perform non-verbal behaviors. The study implemented this system on the Robot Operating System (ROS) platform.
      </p>
        <img src={L51} alt="img1" />

      <h6>Results:</h6>
      <p>
        The paper used mixed model ANOVA to analyze data, with interaction type (individual vs. group) and session as factors. Results indicated that the individual condition enhanced story recall, but emotional interpretation depended more on story difficulty than interaction type. Interactive narratives with multiple robots were found to support children's social skill development, regardless of interaction type.
      </p>

      <h6>Conclusion:</h6>
      <p>
        This paper mainly showed that individual interactions with robots improved story recall, while emotional interpretation depended on story difficulty, not interaction type. Interactive narratives with multiple robots supported children's social skill development regardless of interaction. More research is needed to explore the long-term impact of interaction type on children's learning with socially assistive robotics.
      </p>

      <h6>Limitations:</h6>
      <p>
        Exploratory approach, lacking specific hypotheses, may limit drawing definitive conclusions. It solely examined individual vs. group interaction effects on story recall and emotional interpretation, neglecting other influential factors for social skill development. Its between-subjects design might restrict generalizability to other contexts or populations. The study also did not explore the long-term impact of various interaction types with socially assistive robotics, which could provide valuable insights into sustained intervention effects.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(5)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>
        </div>
    );
};

export default ZahidL;
